import React from "react";
import { FaHome } from "react-icons/fa";
import { MdDashboard, MdInsertChart } from "react-icons/md";
import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <div
      className=" "
      style={{
        minHeight: "200px",
        background: "rgba(108, 117, 121, 0.1)",
      }}
    >
      <h5 className="text-center">RAIL-SETU</h5>
      <div className="text-center"> (A Jabalpur division project)</div>
      <h6 className="text-center">
        Developed and Maintained by DRM IT CELL Jabalpur
      </h6>
      <div className="container-fluid mt-3" style={{ fontSize: "15px" }}>
        <div className="row m-1">
          <div className="col-2 text-end">
            <FaHome />
          </div>
          <div className="col-8">
            <Link to="/" className="navbar-brand">
              <div className="row">
                <button
                  className="btn btn-sm btn-outline-primary"
                  type="button"
                >
                  Home
                </button>
              </div>
            </Link>
          </div>
        </div>

        <div className="row m-1">
          <div className="col-2 text-end">
            <MdDashboard />
          </div>

          <div className="col-8">
            <Link to="/DashBoard" className="navbar-brand">
              <div className="row">
                <button
                  className="btn btn-sm btn-outline-primary"
                  type="button"
                >
                  Dashboard
                </button>
              </div>
            </Link>
          </div>
        </div>
        <div className="row m-1">
          <div className="col-2 text-end">
            <MdInsertChart />
          </div>
          <div className="col-8">
            <Link to="/InsertData" className="navbar-brand">
              <div className="row">
                <button
                  className="btn btn-sm btn-outline-primary"
                  type="button"
                >
                  Insert Data
                </button>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Footer;
